module.exports = __webpack_public_path__ + "img/iacp.969b06ec.jpg";